import { useSearchParams } from 'react-router-dom';

import { ActivityDataSource } from '../types';

export function useSource(): ActivityDataSource | null {
  const [search] = useSearchParams();
  return search.get('source') as ActivityDataSource | null;
}
